<template>
  <div class="without-placeholder">
    <template v-if="showOldFormat === true">
      <input class="otp-input-type" type="text" v-for="(digit, index) in value" :key="index" maxlength="1" @keyup="changeDetection($event, index)" @keydown.space="event => event.preventDefault()" :data-index="index" v-model="value[index]" />
    </template>
    <template v-if="showOldFormat === false">
      <input
        class="otp-input-type"
        type="text"
        v-for="(digit, index) in value"
        :key="index"
        v-model="value[index]"
        maxlength="1"
        @keyup="changeDetection($event, index)"
        @keydown.space="event => event.preventDefault()"
        :class="{
          isItInBold: fixedCharacters && fixedCharacters.indexOf(String(index)) > -1
        }"
        :readonly="fixedCharacters && fixedCharacters.indexOf(String(index)) > -1"
        :data-index="index"
      />
    </template>
  </div>
</template>

<script>
export default {
  name: "otp-input-service",
  components: {},
  props: ["value", "showOldFormat"],
  data() {
    return {
      fixedCharacters: []
    };
  },
  mounted() {
    this.fixedCharacters = this.$el.getAttribute("data-fixedCharacters") == "" || this.$el.getAttribute("data-fixedCharacters") == null ? [] : this.$el.getAttribute("data-fixedCharacters").split(",");
  },
  methods: {
    changeDetection(ele, index) {
      if (ele.which == 9 || ele.which == 16) {
        return;
      }
      if (ele.target.value == "") {
        this.value[index] = null;
      }
      if (ele.target.nextElementSibling != null && ele.which != 8 && ele.which != 37) {
        ele.target.nextElementSibling.focus();
      }
      if (ele.target.previousElementSibling != null && (ele.which == 8 || ele.which == 37)) {
        ele.target.previousElementSibling.focus();
      }
    }
  }
};
</script>
<style lang="scss">
.otp-input-type {
  border: none;
  width: 26px;
  text-align: center;
  border-bottom: 2px solid #666669;
  margin-left: 6px;
  height: 26px;
  padding-top: 5px;
  &.participant-list {
    border-bottom: 1px solid #e4e8eb;
    margin-left: 7px;
    height: 27px;
    padding-top: 7px;
  }
  &.isItInBold {
    font-weight: 600;
  }
}
</style>
